// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Re-z","landingPageVideo":"Se-z","play":"Te-z","iframeVideo":"Ue-z","playHidden":"Ve-z","fullwidth":"We-z"};